import getters from '@/shared/store/cus-ecommerce/getters';
import mutations from '@/shared/store/cus-ecommerce/mutations';
import actions from '@/shared/store/cus-ecommerce/actions';
import state from '@/shared/store/cus-ecommerce/state';

export default {
  namespaced: true,
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
};
